import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { ReactComponent as OwTextIcon } from "assets/img/ow-text-icon.svg";
import { MyHrLoginTwoFactorVerifyEmailCode } from "my-hr/components";

interface MyHrLoginTwoFactorLoginEmailProps {
  onForward: () => void;
  onCancel: () => void;
  userData: any; // Replace 'any' with a more specific type if available
}

export const MyHrLoginTwoFactorLoginEmail: React.FC<
  MyHrLoginTwoFactorLoginEmailProps
> = ({ onForward, onCancel, userData }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: "304px",
      }}
    >
      <OwTextIcon />
      <Typography
        variant="h6"
        sx={{
          marginTop: "24px",
        }}
      >
        {t("MY_HR_2FA_AUTHENTICATION")}
      </Typography>
      <Box
        sx={{ textAlign: "center", marginTop: "24px", marginBottom: "16px" }}
      >
        <Typography variant="body1">{t("MY_HR_EMAIL_CODE_REQUEST")}</Typography>
      </Box>
      <MyHrLoginTwoFactorVerifyEmailCode
        onForward={onForward}
        onCancel={onCancel}
        userData={userData}
      />
    </Box>
  );
};

export default MyHrLoginTwoFactorLoginEmail;
